import React, { useState, Fragment, useEffect, useContext } from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@common/Button";
import { SearchSVG } from "@icons";
import styled from "styled-components";
import Input from "@common/Input";
import Select from "@common/Select";
import { useTranslation } from "react-i18next";
import { respondTo } from "@utilities/styled-components";
import { ShoppingListsContext } from "../CtxProvider";
import { useDispatch, useSelector } from "react-redux";

import {
  orderFilterDetails,
  orderSelector,
} from "@slices/Enquiry/Order/orderHistory";
import { useGetLoggedInUserInfo } from "@hooks";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import {
  fetchGetShoppingListSearchDetails,
  initializeShoppingListsDetailsLoader
} from "@slices/shoppingLists/getShoppingListSearchDetails";

const DrawerRight = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
`;

const Drawer = styled.figure`
  width: 400px;
  ${respondTo.xs`
     width: calc(100vw - 20px);
    `}
  ${respondTo.sm`
     width: calc(100vw - 20px);
    `}
      ${respondTo.md`
      width: 400px;
    `}
`;

const DrawerHeader = styled.h3`
  padding: 10px 0px 15px 15px;
  font-weight: var(--font-weight-medium);
  border: var(--thin-border) var(--gray-4);
  margin-bottom: 15px;
`;

const DrawerCaption = styled.figcaption`
  padding: 0px 20px;
`;
const Filterdiv = styled.div`
  padding: 10px;
`;

export default function ShoppingListSearch(Props: any) {
  const webSettingsData: any = useContext(WebSettingsContext);
    const { isMobile, userInfo, webSettings } =
      useContext(ShoppingListsContext);
  const { t, i18n } = useTranslation();
  const searchstate = useSelector(orderSelector);
  const [state, setState] = React.useState<any>({
    right: false,
  });

  const sessionId = useGetLoggedInUserInfo()?.sessionId;
  const dispatch = useDispatch();

  useEffect(() => {
    if (sessionId) {
      dispatch(orderFilterDetails(sessionId));
    }
  }, [sessionId]);

  const handleKeyPress = (target: any) => {
    if (target.charCode === 13) {
      onSearchHandler();
    }
  };

  const [listName, setListName] = useState<string>("");
  const [customerState, setCustomerState] = useState<any>(
    webSettingsData?.defaultCustomerCode
  );  
  const [listType, setListType] = useState<string>("YourList");  

  useEffect(() => {
    setCustomerState(webSettingsData?.defaultCustomerCode);
  }, []);

  const filterSettings = searchstate?.orderHistory?.searchFilterSettings;

  const onCustomerChange = (code: string) => {
    setCustomerState(code);
  };

  const onListTypeChange = (code: string) => {
    setListType(code);
  };

  const onClearHandler = () => {
     dispatch(initializeShoppingListsDetailsLoader());

    dispatch(
      fetchGetShoppingListSearchDetails(userInfo?.sessionId, {
        OrderBy: "DESC",
        SortBy: "ListId",
        PageNo: 1,
      })
    );

    setCustomerState(webSettingsData?.defaultCustomerCode);
    setListName("");
    setListType("YourList");  
    Props.isSearched(false);
    setState(false);
  };

  useEffect(() => {
    if (!searchstate?.orderHistory?.isFilterApply) {
      onClearHandler();
    }
  }, [searchstate?.orderHistory?.isFilterApply]);
  // Open and Close Drawer Handler
  const toggleDrawer = (anchor: any, open: any) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const onSearchHandler = () => {

    dispatch(initializeShoppingListsDetailsLoader());

    dispatch(
      fetchGetShoppingListSearchDetails(userInfo?.sessionId, {
        ListId: listName,
        CustomerId: customerState || userInfo?.defaultCustomerCode,
        ListType: listType,
        ResultsPerPage: 10,
        OrderBy: "DESC",
        SortBy: "ListId",
        PageNo: 1,
      })
    );

    Props.searchQueryValues({
       ListId: listName,
       CustomerId: customerState || userInfo?.defaultCustomerCode,
       ListType: listType,
    })
    Props.isSearched(true);
    setState(false);
  };

  return (
    <div>
      {["Click"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            variant="solid"
            style={{ padding: "7px 16px" }}
            onClick={toggleDrawer(anchor, true)}
          >
            <SearchSVG className="icon" />
            <span>{t("CON_SEARCH")}</span>
          </Button>

          <SwipeableDrawer
            anchor={"right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            <div className="row">
              <DrawerRight className="col-md-12">
                <Drawer>
                  <DrawerHeader>
                    {t("CON_SEARCH")}
                    <span style={{ float: "right", cursor: "pointer" }}>
                      <CloseIcon
                        onClick={toggleDrawer(anchor, false)}
                        className="primary-icon-3 icon-md"
                      />
                    </span>
                  </DrawerHeader>
                  <div>
                    <DrawerCaption>                   
                      <div>
                        <Input
                          type="text"
                          placeholder={`${t("CON_LIST_NAME")}`}
                          showLabel={true}
                          labelText={t("CON_LIST_NAME")}
                          onChange={(value: any) => setListName(value)}
                          value={listName}
                          onKeyPress={(e: any) => handleKeyPress(e)}
                        />
                      </div>

                      <p></p>
                      <hr />
                                            
                      {filterSettings?.filterBeans?.filter(
                        (data: any) =>
                          data.filterName == "CON_CUSTOMER" && data.isEnabled
                      ).length > 0 && (
                        <Filterdiv>
                          <Select
                            showLabel={true}
                            onChange={onCustomerChange}
                            options={searchstate?.orderHistory?.searchFilterslist?.customerList?.map(
                              (item: any) => {
                                return {
                                  label: item.description,
                                  value: item.code,
                                  selected:
                                    item.code ===
                                    webSettingsData?.defaultCustomerCode,
                                };
                              }
                            )}
                            value={customerState}
                            labelText={t("CON_CUSTOMER")}
                          />
                        </Filterdiv>
                      )}

                      <Filterdiv>
                          <Select
                            showLabel={true}
                            onChange={onListTypeChange}
                            options={[
                              {label: "YourList", value: "YourList"},
                              {label: "All", value: "All"},
                              {label: "SharedList", value: "SharedList"}
                            ]}
                            value={listType}
                            labelText={t("CON_LIST_TYPE")}
                          />
                        </Filterdiv>

                      <div
                        style={{
                          justifyContent: "space-between",
                          marginTop: "24px",
                        }}
                        className="row"
                      >
                        <Button
                          style={{
                            width: "45%",
                            marginTop: "8px",
                            paddingRight: "20px",
                          }}
                          onClick={onClearHandler}
                        >
                          <span>{t("CON_CLEARALL")}</span>
                        </Button>
                        <Button
                          variant="solid"
                          style={{ width: "45%", marginTop: "8px" }}
                          onClick={onSearchHandler}
                        >
                          <span>{t("CON_SEARCH")}</span>
                        </Button>
                      </div>
                    </DrawerCaption>
                  </div>
                </Drawer>
              </DrawerRight>
            </div>
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
